<template>
    <el-dialog
        title="审核"
        :visible.sync="dialogStatusVisible"
        width="25%"
        :modal="false"
    >
        <div class="check-status">
            <el-radio-group v-model="checkQueryInfo.checkStatus" size="small">
                <el-radio label="1" border>通过</el-radio>
                <el-radio label="2" border>不通过</el-radio>
            </el-radio-group>
            <br />
            <br />
            <br />
            <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入审核描述"
                v-if="this.checkPath == '/sys/activitiesSignupData/update/open'"
                v-model="checkQueryInfo.verifyDesc"
            >
            </el-input>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogStatusVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateStatus">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: ["checkQuery"],
    data() {
        return {
            // 控制审核状态弹框的显示隐藏
            dialogStatusVisible: false,
            // 审核参数
            checkQueryInfo: {},
            // 更新路径
            checkPath: "",
        };
    },
    methods: {
        init(path) {
            this.dialogStatusVisible = true;
            this.checkPath = path;
            this.checkQueryInfo = { ...this.checkQuery };
            if (this.checkPath === "/sys/activitiesSignupData/update/open") {
                this.checkQueryInfo = JSON.parse(
                    JSON.stringify(this.checkQueryInfo).replace(
                        /verifyStatus/g,
                        "checkStatus"
                    )
                );
            }
            if (this.checkPath === "/consult/updateAuditStatus") {
                this.checkQueryInfo = JSON.parse(
                    JSON.stringify(this.checkQueryInfo).replace(
                        /auditStatus/g,
                        "checkStatus"
                    )
                );
            }
        },
        // 更新审核状态
        updateStatus() {
            if (
                this.checkPath === "/news/update" ||
                this.checkPath === "/industrialPark/update" ||
                this.checkPath === "/demoEnterprise/update"
            ) {
                this.checkQueryInfo.checkStatus = parseInt(
                    this.checkQueryInfo.checkStatus
                );
            }
            if (this.checkPath === "/sys/activitiesSignupData/update/open"||this.checkPath === '/company/update') {
                this.checkQueryInfo = JSON.parse(
                    JSON.stringify(this.checkQueryInfo).replace(
                        /checkStatus/g,
                        "verifyStatus"
                    )
                );
            }
            if (this.checkPath === '/consult/updateAuditStatus') {
                this.checkQueryInfo = JSON.parse(
                    JSON.stringify(this.checkQueryInfo).replace(
                        /checkStatus/g,
                        "auditStatus"
                    )
                );
            }
            this.$ajaxPost(this.checkPath, this.checkQueryInfo).then(
                ({ data }) => {
                    console.log('@')
                    if (data.code === 0) {
                        console.log(data);
                        this.$message.success("审核成功");
                        this.$emit("updateComputed");
                        this.dialogStatusVisible = false;
                    }
                }
            );
        },
    },
};
</script>

<style lang="less" scoped>
</style>